export const checkSystemn =() =>{
  let u = window.navigator.userAgent,
    app = window.navigator.appVersion;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  let screen_width = window.screen.width;
  let screen_height = window.screen.height;
  //根据屏幕分辨率判断是否是手机
  if (isAndroid || isIOS) {
    return 'mobile'
  } else {
    if (screen_width < 500 && screen_height < 960) return 'mobile';
    return 'pc';
  }
}